export enum AlertcType {
  linear = 'linear',
  point = 'point'
}



// WEBPACK FOOTER //
// ./src/app/models/enums/alertctype.ts